import { useCallback, useState } from "react";
import LogoMini from "../../../components/icons/LogoMini";
import PlayTriangle from "../../../components/icons/PlayTriangle";
import "../general.scss";
import "./index.scss";
import Popup from "../../../components/Popup";
import { useAnalytics } from "@popped/popshap-kiosk-components";
import { useData } from "../../../context/DataProvider";
import IGOnDemand from "../../../assets/img/SolutionsIcons/AgilysysIGOnDemand.svg";
import { Header } from "../../../components/Header";
import { useLocation } from "react-router-dom";

const IGOnDemandFPage = () => {
    const { logEvent } = useAnalytics();
    const { addFlow, location } = useData()!;
    const _logEvent = useCallback(async (type: string, value: string, id?: string) => {
        await logEvent(type, value, { kiosk: location, id: id })
    }, [logEvent,location])
    const [showVideo, setShowVideo] = useState<boolean>(false);
    const { pathname } = useLocation();
    const altText = () => {
      if (pathname.split("/")[1] === "communities")
        return "resident"
      if (pathname.split("/")[1] === "higher-education")
        return "student and faculty"
      else
        return "guest"
    }
    const altText2 = () => {
      if (pathname.split("/")[1] === "communities")
        return "resident"
      if (pathname.split("/")[1] === "higher-education")
        return "diner"
      else
        return "guest"
    }
    const altText3 = () => {
      if (pathname.split("/")[1] === "communities")
        return "residents"
      if (pathname.split("/")[1] === "higher-education")
        return "students and faculty"
      else
        return "guests"
    }
    return (
      <div className="page splash IGOnDemandFPage">
        <div className="page-title">
          <img src={IGOnDemand} alt="" />
        </div>
        <Header />
        <div className="text-blocks">
          <div className="std-text">
            A complete cloud-native contactless self-service F&B ordering
            solution that offers an intuitive customer-facing order
            and pay experience. IG OnDemand allows staff and visitors to place and pay for
            orders using their own device – phone, tablet, laptop – for pick-up
            or delivery orders, as well as for a table-side order and pay
            experience.{"\n\n"}
            It supports ordering for multiple customers at a table over the course
            of a meal using their own devices making the ordering process
            touchless while freeing up servers to spend more time with customers. 
            The result is dramatically increased revenue
            opportunities and more chances to enhance service.
          </div>
          {/*<div className="std-text">
                It supports ordering for multiple guests at a table over the
course of a meal using their own devices making the
ordering process touchless while freeing up staff to soend
more time with guests. The result is dramatically increased
revenue opportunities and more chances to enhance guest
service.
                </div>*/}
        </div>
        <div
          className="play-video"
          onClick={() => {
            _logEvent("click", "Solutions - IG OnDemand", "Play Video");
            addFlow("Play Video");
            setShowVideo(true);
          }}
        >
          <PlayTriangle />
          Play Video
        </div>
        <img
          className="img-1"
          src={
            "https://storage.googleapis.com/popshap-kiosks-dev.appspot.com/agilysys/FeaturedSolutions/IGOnDemand3.png"
          }
          alt=""
        />
        <img
          className="img-2"
          src={
            "https://storage.googleapis.com/popshap-kiosks-dev.appspot.com/agilysys/FeaturedSolutions/IGOnDemand2.png"
          }
          alt=""
        />
        <Popup
          showPopup={showVideo}
          setShowPopup={() => setShowVideo(false)}
          disableOffClick={true}
        >
          <>
            {showVideo && (
              <video
                autoPlay
                controls
                src={
                  "https://storage.googleapis.com/popshap-kiosks-dev.appspot.com/agilysys/FeaturedSolutions/videos/InteractiveIGOnDemand2.mp4"
                }
              />
            )}
          </>
        </Popup>
      </div>
    );
}

export default IGOnDemandFPage;